export default __webpack_public_path__ + "static/media/jasim.84a9bb1b.jpg";